import axios from 'axios';

const API_ADRESSE_URL = 'https://api-adresse.data.gouv.fr/search/';

/**
 * Fetches addresses from the API Adresse.
 * @param {string} search - The search query.
 * @param {Object} extraParams - Additional parameters to pass to the API.
 * @returns {Promise} A promise that resolves to the response of the API call.
 */
export async function getAdresses(search, extraParams = {}) {
  return axios.get(API_ADRESSE_URL, {
    params: { q: search, limit: 10, ...extraParams },
  });
}

/**
 * Fetches parcelles from the Cadastre API.
 * @param {Object} params - The parameters to pass to the API.
 * @returns {Promise} A promise that resolves to the response of the API call.
 */
export async function getParcelles(params) {
  // If prefixe is an empty string, set it to null
  if (params.prefixe === '') {
    params.prefixe = null;
  }

  return axios.get(`${import.meta.env.VITE_CADASTRE_API_URL}/parcelles/idu`, {
    params,
    headers: {
      'ns-api-key': import.meta.env.VITE_CADASTRE_API_KEY,
    },
  });
}
/**
 * Fetches communes from the API Adresse.
 * @param {string} search - The search query.
 * @returns {Promise} A promise that resolves to the response of the API call.
 */
export async function getCommunes(search) {
  return getAdresses(search, { type: 'municipality' });
}
